import React from "react";
import EditDetailsForm from "./components/liveCamera";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
function Camera() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox>
        <EditDetailsForm />
      </MDBox>
    </DashboardLayout>
  );
}

export default Camera;
